<div class="title">Joined Players</div>
<div *ngIf="gameApi.players$ | async as players" class="container">
  <div *ngFor="let player of players" class="card">
    <app-joined-player-list-item [player]="player"></app-joined-player-list-item>
  </div>
  <div *ngIf="players.length === 0">
    No players yet!
  </div>
</div>
